import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/800202'
    },
    {
      path: '/my',
      component: () => import('./views/my-home.vue'),
      redirect: '/my/welcome',
      children: [
        {
          path: '/my/welcome',
          name: 'welcome',
          component: () => import('./views/my/welcome.vue'),
          meta: {
            title: '欢迎页-买家中心-积分商城'
          }
        },
        {
          path: '/my/jifen',
          name: 'jifen',
          component: () => import('./views/my/jifen-list.vue'),
          meta: {
            title: '店铺积分-买家中心-积分商城'
          }
        },
        {
          path: '/my/order',
          name: 'order',
          component: () => import('./views/my/order-list.vue'),
          meta: {
            title: '订单列表-买家中心-积分商城'
          }
        },
        {
          path: '/my/order/:id',
          name: 'orderDetil',
          component: () => import('./views/my/order-detail.vue'),
          meta: {
            title: '订单详情-买家中心-积分商城'
          }
        },
        {
          path: '/my/jifen/:id',
          name: 'jifenDetil',
          component: () => import('./views/my/jifen-detail.vue'),
          meta: {
            title: '积分明细-买家中心-积分商城'
          }
        }
      ]
    },
    {
      path: '/my/welcomes',
      name: 'welcomeopen',
      component: () => import('./views/my/welcome.vue'),
      meta: {
        title: '欢迎页-买家中心-积分商城'
      }
    },

    {
      path: '/my/jifens',
      name: 'jifenopen',
      component: () => import('./views/my/jifen-list.vue'),
      meta: {
        title: '店铺积分-买家中心-积分商城'
      }
    },

    {
      path: '/my/orders',
      name: 'orderopen',
      component: () => import('./views/my/order-list.vue'),
      meta: {
        title: '订单列表-买家中心-积分商城'
      }
    },
    {
      path: '/my/order/s/:id',
      name: 'orderDetilopen',
      component: () => import('./views/my/order-detail.vue'),
      meta: {
        title: '订单详情-买家中心-积分商城'
      }
    },
    {
      path: '/my/jifen/s/:id',
      name: 'jifenDetilopen',
      component: () => import('./views/my/jifen-detail.vue'),
      meta: {
        title: '积分明细-买家中心-积分商城'
      }
    },
    {
      path: '/:id',
      name: 'cart',
      component: () => import('./views/cart.vue'),
      meta: {
        title: '首页-积分商城'
      }
    },
    {
      path: '/checkout/:id',
      name: 'checkout',
      component: () => import('./views/checkout.vue'),
      meta: {
        title: '确认订单-积分商城'
      }
    },
    {
      path: '/product/:id/:id',
      name: 'product',
      component: () => import('./views/product.vue'),
      meta: {
        title: '礼品详情-积分商城'
      }
    },
    {
      path: '/checkout/ok/:id/',
      name: 'checkoutOk',
      component: () => import('./views/order-ok.vue'),
      meta: {
        title: '下单成功-积分商城'
      }
    },
    {
      path: '/index/404',
      name: '404',
      component: () => import('./components/404.vue'),
      meta: {
        title: '404-积分商城'
      }
    },
    {
      path: '*',
      redirect: '/index/404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

export default router;
